import React from 'react';
import Spinner from './Spinner';

const services = ["minecraft", "HomeAssistant", "Plex", "Jellyfin", "Nextcloud", "web"];

const ServiceSpinner: React.FC = () => {
  return (
    <Spinner items={services} interval={2700} className="text-primary" />
  );
};

export default ServiceSpinner;
